export enum CPProgramWeekTwoStep {
    WhatAreValuesStep = 'what-are-values',
    UnderstandingYourValuesStep = 'understanding-your-values',
    ValuesAssessmentStep = 'assessing-your-values',
    ThinkingMoreAboutValuesStep = 'thinking-more-about-values',
    ValuesAreasRatingStep = 'rate-your-life-areas',
}

export interface ValuesAssessmentDomain extends ValuesAssessmentDomainBase {
    title: string;
}

export interface ValuesAssessmentDomainBase {
    topics: string[];
    additionalInfo: string;
    rate: number;
    additionalRate: number;
}

export interface ValuesAssessmentDomainRequested extends ValuesAssessmentDomainBase {
    domain: string;
}

export interface ChangeValuesAssessmentAreaFieldActionArguments {
    domainTitle: string;
    field: string;
    value: string | number;
}
